module.exports = __webpack_public_path__ + "img/edit-pw.876b253e.svg";